(ns app.front.view.group.admin.fees.group.group-core
  (:require [app.domain.fee.model :as fee-model]
            [app.front.ui :as ui]
            [app.front.ui.column-select :as columns]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.inline-editable :as inline-editable]
            [app.front.view.group.admin.fees.group.group-events :as fg-events]
            [app.front.view.group.admin.fees.group.group-subs :as fg-subs]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [reagent.core :as r]))

(defn- fee-group-option-icon
  "A clickable icon on the group select option with optional confirmation dialog"
  [tr group-id icon description-tr-key selected? on-click confirm-tr-key]
  (let [icon-opts {:class-name  "ml-1 relative"
                   :style       {:top "2px"}
                   :icon        icon
                   :width       "14"
                   :height      "14"
                   :fill        (if selected? "white" "black")
                   :description (tr [description-tr-key])}]
    (if (nil? confirm-tr-key)
      (cc/icon (assoc icon-opts :on-click on-click))
      [ui/modal-confirmation-button
       {:tr                tr
        :id                (str (name description-tr-key) "-" group-id)
        :modal-class       "text-left"
        :on-yes-click      on-click
        :trigger-icon-opts icon-opts}
       (tr [confirm-tr-key])])))


(defn- wrap-callback
  "Stops the js event from propagating to lower elements"
  [f]
  #(do (.stopPropagation %)
       (f)))


(defn- editable-fee-group
  "A single editable fee group"
  [tr *editing-group-id selected? disabled? {group-id :db/id :as fee-group}]
  (let [on-delete       (wrap-callback #(>evt [::fg-events/delete group-id]))
        on-edit         (wrap-callback #(reset! *editing-group-id group-id))
        on-edit-cancel  #(reset! *editing-group-id nil)
        on-edit-confirm #(do (>evt [::fg-events/edit group-id %])
                             (reset! *editing-group-id nil))
        lang            (<sub [::ui-i18n/editor-language ::gas/allowed-locales])
        group-title     (fee-model/fee-group-title fee-group lang)]
    (if (= group-id @*editing-group-id)
      [inline-editable/i18n-text-field-confirm
       {:tr         tr
        :input-opts {:class               "h-6 p-1 border-0"
                     :auto-focus          true
                     :allowed-locales-sub ::gas/allowed-locales
                     :default-value       (i18n-model/strings-map (:fee-group/titles fee-group)
                                                                  (:fee-group/title fee-group))}
        :on-confirm on-edit-confirm
        :on-cancel  on-edit-cancel}]
      [:div.relative
       [:div.pr-10 group-title]
       (when-not disabled?
         [:div.absolute.right-0
          {:on-click #(.stopPropagation %)
           :style    {:top "-2px"}}
          [fee-group-option-icon tr group-id i/pen :edit selected? on-edit]
          [fee-group-option-icon tr group-id i/trash :delete selected? on-delete :fees/confirm-delete-fee-group]])])))


(defn- fee-group-to-option
  "Creates a column-select compatible, editable and deletable option for the fee group"
  [tr *editing-group-id disabled? fee-group selected-group-id]
  (let [selected? (-> fee-group :db/id (= selected-group-id))]
    {:id        (:db/id fee-group)
     :selected? selected?
     :content   [editable-fee-group tr *editing-group-id selected? disabled? fee-group]}))


(defn fee-group-select
  "A UI component for selecting one of the fee item groups under the currently open authority group fees page.
  Allows the user to add, edit and delete groups.
  Deletion is only allowed if no fee items belong to the group."
  [{:keys [tr disabled? on-change selected-group-id]}]
  (r/with-let [*creating?        (r/atom false)
               *editing-group-id (r/atom nil)]
    (let [fee-schedule-id (<sub [::fg-subs/fee-schedule-id])
          options         (->> (<sub [::fg-subs/fee-groups])
                               (map #(fee-group-to-option tr *editing-group-id disabled? % selected-group-id)))
          on-create       #(swap! *creating? not)]
      [:div.relative.inline-edit
       (when @*creating?
         [inline-editable/popup-wrapper
          {:tr    tr
           :class "top-5 left-2"
           :title :fees/add-group}
          [inline-editable/i18n-text-field-confirm
           {:tr           tr
            :input-opts   {:auto-focus          true
                           :allowed-locales-sub ::gas/allowed-locales}
            :allow-blank? false
            :on-confirm   #(do (reset! *creating? false)
                               (>evt [::fg-events/create fee-schedule-id %]))
            :on-cancel    #(reset! *creating? false)
            :confirm-opts {:class-name "border-0"
                           :text       (tr [:create-new])}
            :cancel-opts  {:class-name "border-0"
                           :text       (tr [:cancel])}}]])
       [columns/column-select {:tr          tr
                               :title       (tr [:fees/group])
                               :options     options
                               :height      (if (some? @*editing-group-id)
                                              "260px"
                                              "200px")
                               :disabled?   disabled?
                               :empty-label :fees/no-groups
                               :on-change   on-change
                               :actions     (when-not disabled?
                                              [{:title    (tr [:fees/new-group])
                                                :on-click on-create}])}]])))
